export default __webpack_public_path__ + "static/account-camera-icon-ce84f843f6ab2fd1a9c12e941dc5ce31.svg";